import { makeAutoObservable } from 'mobx';
import { WEB_PAGE_STATE_ENUMS } from '../../components/ChatWidget/constants';

class Agent {
  constructor() {
    makeAutoObservable(this);
  }

  isAgentPanelOpen = false;
  currentScreen = WEB_PAGE_STATE_ENUMS.Workflows;
  currentSubScreen = '';

  toggleAgentPanel() {
    this.isAgentPanelOpen = !this.isAgentPanelOpen;
  }

  setCurrentScreen(screen) {
    this.currentScreen = screen;
  }

  setCurrentSubScreen(subScreen) {
    this.currentSubScreen = subScreen;
  }
}

const agentStore = new Agent();

export default agentStore;
